export enum InputMask {
  DIGITS = '0*',
  ALPHANUMERIC = 'A*',
  NIT = '000000000-0',
  CUIL = '00-00000000-0',
  CUIT = '00-00000000-0',
  CPF = '000.000.000-00',
  CNPJ = '00.000.000/0000-00',
  RUC_PE = '00000000000',
  DOB = 'd0/M0/0000',
}

export enum InputRegex {
  NUMERIC = '^[0-9]*$',
  ALPHA = '^[a-zA-Z ]*$',
  ALPHANUMERIC = '^[a-zA-Z0-9 ]*$',
  NIT = '^[0-9]{9}[-][0-9kK]{1}$',
  CPF = '([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})',
  CNPJ = '[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}',
  CUIL = '^(20|23|24|27)[-]?[0-9]{8}[-]?[0-9]',
  CUIT = '^(20|23|24|27|30|33|34)[-]?[0-9]{8}[-]?[0-9]',
  RUC_PE = '^(10|20|15|16|17)[0-9]{9}',
  DATE = '[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}',
}
